"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RideStepPopup = RideStepPopup;
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _ButtonBase2 = _interopRequireDefault(require("@mui/material/ButtonBase"));
var _styles = require("@mui/material/styles");
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _button = require("../button");
var _externalMediaList = require("../external-media-list");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function RideStepPopup(_ref) {
  let {
    theme,
    step,
    openPhotoDialog,
    onRemove,
    onEdit,
    onClose
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    title,
    description,
    photos
  } = step;
  const photo = photos.sort((a, b) => a.id && b.id ? a.id - b.id : 0)[0];
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(Wrapper, null, photo && /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "top",
    title: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, photo.title || title, " ", photo.copyright && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA9 ", photo.copyright))
  }, /*#__PURE__*/_react.default.createElement(_ButtonBase2.default, {
    onClick: () => openPhotoDialog(step)
  }, /*#__PURE__*/_react.default.createElement(StyledPhotoWrapper, {
    url: photo.thumbnailUrl || ''
  }))), /*#__PURE__*/_react.default.createElement(CloseButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "left",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    onClick: () => onClose(),
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Close2.default, null)))), /*#__PURE__*/_react.default.createElement(StyledHeader, {
    className: photo ? '' : 'shifted'
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      overflowX: 'hidden'
    }
  }, /*#__PURE__*/_react.default.createElement(StyledTitle, {
    title: title || '',
    variant: "h6"
  }, title))), description && /*#__PURE__*/_react.default.createElement(StyledContent, null, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    component: "p",
    variant: "caption"
  }, description)), 'medias' in step && step.medias.length > 0 && /*#__PURE__*/_react.default.createElement(_externalMediaList.ExternalMediaList, {
    medias: step.medias
  }), (onRemove || onEdit) && step && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 1,
    justifyContent: "flex-end",
    padding: "0 16px 8px"
  }, /*#__PURE__*/_react.default.createElement(_button.Button, {
    color: "error",
    disabled: !step,
    onClick: () => {
      onRemove?.();
      onClose();
    },
    size: "small",
    variant: "outlined"
  }, t('commons.actions.remove')), /*#__PURE__*/_react.default.createElement(_button.Button, {
    color: "primary",
    disabled: !step,
    onClick: () => {
      onEdit?.();
      onClose();
    },
    size: "small",
    variant: "contained"
  }, t('commons.actions.update')))));
}
const Wrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  max-height: max(calc(50vh - 24px), 400px);
  overflow-y: hidden;
  position: relative;
  width: min(100vw - 120px, 350px);
`;
const CloseButtonWrapper = _styledComponents.default.div`
  padding: 8px;
  position: absolute;
  right: 0;
  top: 0;

  button {
    background-color: rgba(255, 255, 255, 0.9);

    &:hover {
      background-color: rgba(255, 255, 255, 0.8);
    }
  }
`;
const StyledPhotoWrapper = _styledComponents.default.div`
  background-color: whitesmoke;
  background-image: ${_ref2 => {
  let {
    url
  } = _ref2;
  return `url(${url})`;
}};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 50%;
  width: 100%;
`;
const StyledHeader = _styledComponents.default.div`
  display: flex;
  flex-shrink: 0;
  padding: 16px 16px 8px 16px;

  &.shifted {
    padding: 16px 54px 8px 16px;
  }
`;
const StyledTitle = (0, _styledComponents.default)(_Typography2.default)`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const StyledContent = _styledComponents.default.div`
  flex-shrink: 1;
  overflow-y: auto;
  padding: 0 16px 16px;
`;